module.exports = "/packs/images/svg/ireland/facilities/diving~e28a928c211fde6ea970f21f63ed188d.svg";